export default __webpack_public_path__ + "static/media/climateDataSet.707f4c76.svg";